import { render, staticRenderFns } from "./alertBlock.vue?vue&type=template&id=5fe63bce&"
import script from "./alertBlock.vue?vue&type=script&lang=js&"
export * from "./alertBlock.vue?vue&type=script&lang=js&"
import style0 from "./alertBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports